import {NgxCurrencyConfig, NgxCurrencyInputMode} from "@dintecom/ngx-currency";

export const CURRENCY_DEFAULT_OPTIONS: Partial<NgxCurrencyConfig> = {
    prefix: '',
    suffix: ' €',
    thousands: ' ',
    decimal: '.',
    precision: 2,
    inputMode: NgxCurrencyInputMode.Natural
};

export const CURRENCY_DEFAULT_POSITIVE: Partial<NgxCurrencyConfig> = {
    ...CURRENCY_DEFAULT_OPTIONS,
    allowNegative: false
};

export const CURRENCY_HACK_INTEGER: Partial<NgxCurrencyConfig> = {
    prefix: '',
    suffix: '',
    thousands: ' ',
    decimal: 'X',
    precision: 0,
    inputMode: NgxCurrencyInputMode.Natural
};

export const CURRENCY_HACK_POSITIVE_INTEGER: Partial<NgxCurrencyConfig> = {
    ...CURRENCY_HACK_INTEGER,
    allowNegative: false
};
